import { useEffect, useMemo, useState } from 'react';
import { eventSort } from '../../../components/commonFunc';
import { TabEventFirstElement } from '../../../components/Contents/blogspage/TabEventFirstElement';
import { getEvents } from '../api/api';
import { HubListingCardLink } from '../layout/HubListingCardLink';
import { HubListingView } from '../layout/HubListingView';
import { usePaginatedItems } from '../layout/usePaginatedItems';

function parseEvents(events) {
  return events.map((eItem) => ({
    postId: eItem.id,
    title: eItem.Title,
    postMedia: eItem.Graphic1,
    postType: eItem.ContentType,
    postDate: eItem.LastUpdated,
    postName: eItem.Relevance,
    eventStartDate: eItem.StartDate,
    eventEndDate: eItem.EndDate,
    eventUrl: eItem.EventPath,
    addressData: {
      address: eItem.Address,
      country: eItem.Country,
      city: eItem.City,
      state: eItem.State,
      zip: eItem.Zip,
      phone: eItem.Phone,
    },
  }));
}

export function EventCardList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const firstItem = items[0];
  const { pageItems, totalPages, currentPage, onPageChange } = usePaginatedItems(items);

  useEffect(() => {
    const loadEvents = async () => {
      setLoading(true);
      try {
        const events = await getEvents();
        setItems(eventSort(parseEvents(events)));
      } catch {
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, []);

  const renderFeatured = (item) => (
    <HubListingCardLink item={item} className="block no-underline text-inherit cursor-pointer">
      <TabEventFirstElement firstBlog={item} />
    </HubListingCardLink>
  );

  return (
    <HubListingView
      title="Events"
      firstItem={firstItem}
      renderFeatured={renderFeatured}
      pageItems={pageItems}
      loading={loading}
      totalPages={totalPages}
      currentPage={currentPage}
      onPageChange={onPageChange}
    />
  );
}
